import React, { Suspense } from "react";
import About from "./components/About";
import Navbar from "./components/Navbar";

const ResumeShowcase = React.lazy(() => import("./components/ResumeShowcase"));
const CaseStudies = React.lazy(() => import("./components/CaseStudies"));
const LiveProjects = React.lazy(() => import("./components/LiveProjects"));
const Projects = React.lazy(() => import("./components/Projects"));
const Skills = React.lazy(() => import("./components/Skills"));
const Education = React.lazy(() => import("./components/Education"));
const Contact = React.lazy(() => import("./components/Contact"));

export default function App() {
  return (
    <main className="relative min-h-screen overflow-hidden bg-slate-950 text-slate-100">
      <div className="pointer-events-none absolute left-10 top-32 h-72 w-72 rounded-full bg-fuchsia-500/20 blur-3xl" />
      <div className="pointer-events-none absolute right-8 top-64 h-80 w-80 rounded-full bg-cyan-500/20 blur-3xl" />
      <div className="pointer-events-none absolute bottom-0 left-1/3 h-72 w-72 rounded-full bg-emerald-500/15 blur-3xl" />
      <Navbar />
      <div className="relative mx-auto max-w-6xl px-4 pb-16 sm:px-6 lg:px-8">
        <About />
        <Suspense
          fallback={
            <div className="my-8 rounded-xl border border-slate-700 bg-slate-900/70 p-4 text-center text-slate-300">
              Loading sections...
            </div>
          }>
          <ResumeShowcase />
          <CaseStudies />
          <LiveProjects />
          <Projects />
          <Skills />
          <Education />
          <Contact />
        </Suspense>
      </div>
    </main>
  );
}



// WEBPACK FOOTER //
// ./src/App.js